// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3jE5X","dragIcon":"SortableItem_dragIcon__tu7Ep","disabled":"SortableItem_disabled__2EdHa"};